import commonUtil from '../../utils/commonUtil';

import {
  GET_LOAD_STORE_STATES,
  GET_STORE_STATES_SUCCESS,
  GET_STORE_STATES_LOAD_FAIL,

  GET_NEAR_BY_STORE_LOADED,
  GET_NEAR_BY_STORE_SUCCESS,
  GET_NEAR_BY_STORE_FAIL,

  SET_NEAR_BY_STORE_LOADED,
  SET_NEAR_BY_STORE_SUCCESS,
  SET_NEAR_BY_STORE_FAIL,

  GET_FAVORITE_STORE_LOADED, 
  GET_FAVORITE_STORE_SUCCESS, 
  GET_FAVORITE_STORE_FAIL,

  GET_NEAR_BY_USER_LOC_LOADED,
  GET_NEAR_USER_LOC_SUCCESS,
  GET_NEAR_USER_LO_FAIL,

  CLEAN_DATA_STORE_LOCATION,
} from './actions';

const initialState = {
  loaded: false,
  data: null,
  storeName: '',
  zipCodeUserLoc: null,
  saveError: {},
  dataByNear: null,
  setNearStore: null,
  extraData: '',

};

export default function storeLocation(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LOAD_STORE_STATES:
      return {
        ...state,
        loading: true,
      };
    case GET_STORE_STATES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_STORE_STATES_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case GET_NEAR_BY_STORE_LOADED:
      return {
        ...state,
        loading: true,
      };
    case GET_NEAR_BY_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        dataByNear: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_NEAR_BY_STORE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        dataByNear: action.error,
        error: action.error,
      };

    case SET_NEAR_BY_STORE_LOADED:
      return {
        ...state,
        loading: true,
      };

    case SET_NEAR_BY_STORE_SUCCESS: {
      const cartHeaderDetails = action.result && action.result;
      const favoriteStore = cartHeaderDetails && cartHeaderDetails.storeName;
      const storeName = (favoriteStore && favoriteStore) || '';
      const storeId = cartHeaderDetails && cartHeaderDetails.id || '';


      return {
        ...state,
        storeName,
        loading: false,
        loaded: true,
        setNearStore: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case SET_NEAR_BY_STORE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case GET_FAVORITE_STORE_LOADED:
      return {
        ...state,
        loading: true,
      };

    case GET_FAVORITE_STORE_SUCCESS: {
      const favoriteStoreData = action.result && action.result;
      const favoriteStore = favoriteStoreData?.storeName;
      const storeName = favoriteStore || '';
     
      return {
        ...state,
        storeName,
        loading: false,
        loaded: true,
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case GET_FAVORITE_STORE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case GET_NEAR_BY_USER_LOC_LOADED:
      return {
        ...state,
        loading: true,
      };

    case GET_NEAR_USER_LOC_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        zipCodeUserLoc: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case GET_NEAR_USER_LO_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        zipCodeUserLoc: 'Error con el servicio de Geolocalizacion de Google',
        data: null,
        error: action.error,
      };

    case CLEAN_DATA_STORE_LOCATION:
      return {
        ...state,
        zipCodeUserLoc: null,
        setNearStore: null,
        dataByNear: null,
      };

    default: {
      return state;
    }
  }
}

